import React from 'react'
import "./NmewsboZedliQtieDetails.css"
import ImgWed from "../assets/wedding.jpg";


const NmewsboZedliQtieDetails = () => {
  return (
    <div className='bg-container'>
        <div className='main-container'>
            <div className='img-container'>
                <img className="ImgWed"
                src={ImgWed} alt="Pr" />
            </div>
            <h1>ኣብ ሻሎም ወሓዚ ህይወት ቤተክርስትያን - ካምፓላ ኡጋንዳ ክምርዓዉ ንዝወሰኑ ተጻመድቲ ዝግበር ቅድመ መርዓ መሕትት</h1>
            <div className='list-container'>
               <ol>
                <li>
                ብዕድመ ብጹሓት ዝኾኑ ተጻይ ጾታ፡ ንጐይታ የሱስ ክርስቶስ ከም ናይ ግሊ መድሓኒ ድሕሪ ምቅባል ብጥምቀት ማይ እተጠመቁ ክኾኑ ይግባእ።
                </li>
                <li>
                ሓዲኦም ወይ ክልቲኦም ካብቶም ተጻመድቲ ቅጺ ኣባልነት ዝመልኡ ኣባላት ክኾኑ ይግባእ።
                </li>
                <li>
                ተጻመድቲ ናይ መርዓ መደቦም ቅድሚ 3 ወርሒ ንማሕበር ከፍልጡ ይግባእ ። ምስክርነት ህይወቶም ዝገልጽ መማዕቆቢ ወረቀት ካብታ ዝነበርዋ ማሕበር ከቅርቡ ይግባእ።
                </li>
                <li>
                Single ምካኖም ዘርእይ ወረቀት ኣብ ጥቃኦም ካብ ዘሎ መንግስታዊ ትካል ከቅርቡ ይግባእ
                </li>
                <li>
                ዕለተ መርዓ ማሕበር ኣምላኽ ምስ ኩሉ መደባታ ብዝጥዕም ዘሎ ክፉት ግዜ ምስ ኣፍለጠት ተመርዓውቲ ምስ ወለዲ ተመያይጦም ግዜ መርዓ  ክቆጽሩ ይግባእ።
                </li>
                <li>
                ክልቲኦም ተጻመድቲ ኣብ እተርኽብሉ ቤተክርስትያን ካብ እትቅበሎም ትካላት ጥዕና ናይ H.I.V  እተመረመርሉ ውጽኢት ዘርእይ ናይ ሕክምና  ወረቀት ከቅርቡ ይግባእ ።
                </li>
               </ol>
            </div>   
            <div className='final-notice'>
                <div className='blue-bg'>
                    <span>ኣገዳሲ ሓበሬታ</span>
                    <p>
                    ነዚ ተዘርዚሩ ዘሎ ቅጥዒ ዘማልኡ ኩሎም ሻሎም ወሓዚ ህይወት ቤተክርስትያን ካምፓላ ኡጋንዳ ሕጋዊ ቃል ኪዳን ተአስር። ንዝያዳ ሓበሬታ በዚ ዝስዕብ ቁ/ስልኪ ተወከሱ 0703449895
                    </p>
                </div>
            </div>         
        </div>
    </div>
  )
}

export default NmewsboZedliQtieDetails